import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

/**
 * A lead's reported outcome, or the fact that there isn't one.
 *
 * A missing outcome renders as "no reply yet" rather than blank on purpose: an
 * empty cell reads as "nothing to do here", and it is the opposite — an
 * unanswered lead is the one row on the screen that wants attention.
 */

const COLOR: Record<string, "success" | "warning" | "error" | "info" | "default"> = {
  delivered: "default",
  contacted: "info",
  quoted: "info",
  won: "success",
  lost: "default",
  bad_lead: "error",
};

export function OutcomeChip({ outcome }: { outcome: string | null }) {
  if (outcome === null || outcome === "delivered") {
    return (
      <Tooltip title="Nothing reported for this lead yet.">
        <Chip label="no reply yet" color="warning" variant="outlined" />
      </Tooltip>
    );
  }
  return <Chip label={outcome} color={COLOR[outcome] ?? "default"} variant="outlined" />;
}
